import { createAnalyticsStore } from "@/store/Analytic/create-chart-store";

export const useNewsStatDynamicCategoryStore = createAnalyticsStore(
  "countryStatDynamicRubrics",
  "Analytics/category/dynamics/:projectId",
  { loadStatType: "withCategories" }
);